/**
 *
 * IconText
 *
 */
import { Box } from '@mui/material';
import React, { CSSProperties, memo } from 'react';
import fonts from 'app/assets/styles/fonts';
import colors from 'app/assets/styles/colors';
import LightTooltip from '../LightTooltip';
import { makeThemeStyle, NestedCssProperties } from 'styles/makeThemeStyle';

export interface IconTextStyleProps {
  iconStyle?: NestedCssProperties<CSSProperties>;
  textStyle?: NestedCssProperties<CSSProperties>;
  wrapperStyle?: NestedCssProperties<CSSProperties>;
}

interface Props extends IconTextStyleProps {
  icon: React.ReactNode;
  text: React.ReactNode;
  enableTooltip?: boolean;
}

const useStyles = makeThemeStyle<IconTextStyleProps>(() => ({
  icon: (props?: IconTextStyleProps) => ({ ...props?.iconStyle }),
  text: (props?: IconTextStyleProps) => ({ ...props?.textStyle }),
  wrapper: (props?: IconTextStyleProps) => ({ ...props?.wrapperStyle }),
}));

export const IconText: React.FC<Props> = ({
  icon,
  text,
  enableTooltip = false,
  ...rest
}) => {
  const classes = useStyles(rest);
  return (
    <>
      <Box
        display="flex"
        alignItems="baseline"
        color={colors.arcaneNavy}
        className={classes.wrapper}
      >
        <Box mr={1} className={classes.icon}>
          {icon}
        </Box>
        <Box
          textOverflow="ellipsis"
          overflow="hidden"
          whiteSpace="nowrap"
          fontWeight={500}
          fontSize={fonts.default}
          className={classes.text}
          lineHeight="18px"
        >
          <LightTooltip
            disableHoverListener={!enableTooltip}
            placement="top"
            title={text || ''}
          >
            <span>{text}</span>
          </LightTooltip>
        </Box>
      </Box>
    </>
  );
};

export default memo(IconText);
